<matrix-generic-table
  [columns]="columns()"
  [data]="data()"
  [totalRecords]="totalRecords()"
  [rows]="rows()"
  [loading]="loading()"
  (queryChange)="onQueryChange($event)"
></matrix-generic-table>
